import { Button, Checkbox, FormControlLabel, FormGroup, Typography } from "@material-ui/core";
import { API, graphqlOperation } from "aws-amplify";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import translate from "../../../i18n/translate";
import { Createfeedback } from "../../../queries";
import RollbarErrorTracking from "../../../utils/RollbarErrorTracking";
import StarRatingBlock from "../StarRatingComponent/StarRating";
import "./SessionRatinPopup.css";
import allActions from "../../../redux/actions";

const SessionRatingComponent = (props: any) => {
  const allInfo = useSelector((state: any) => state);
  const dispatch = useDispatch();
  const [starRating, setStarRating] = useState(0);
  const [submitButton, toggleSubmit] = useState(true);
  const [reasonFlag, toggleReasonFlag] = useState(false);
  const [comment, setComment] = useState(props.sessionRating.Comment != "undefined" ? props.sessionRating.Comment : "");
  const [, toggleDialog] = useState(true);
  const [isReadOnly, setReadOnly] = useState(props.sessionRating.IsReadOnly);
  const [ReminderFlag, setReminder] = useState(false);

  const [state, setState] = React.useState({
    Content: props.sessionRating.Content,
    Teacher: props.sessionRating.Teacher,
    Technology: props.sessionRating.Technology,
  });
  const { Teacher, Content, Technology } = state;

  useEffect(() => {
    setComment(props.sessionRating.Comment != "undefined" ? props.sessionRating.Comment : "");
    setReadOnly(props.sessionRating.IsReadOnly);
    const reasonValues: any = {
      Content: props.sessionRating.Content,
      Teacher: props.sessionRating.Teacher,
      Technology: props.sessionRating.Technology,
    };
    setState(reasonValues);

    if (!isNaN(props.sessionRating.Rating)) {
      setStarRating(parseInt(props.sessionRating.Rating));
    }
  }, [props, allInfo.getLearnerFeedback]);

  useEffect(() => {
    if (starRating <= 3 && starRating !== 0) {
      toggleReasonFlag(true);
      if (
        (state.Content === true || state.Teacher === true || state.Technology === true) &&
        comment !== "" &&
        comment !== undefined &&
        !isReadOnly
      ) {
        toggleSubmit(false);
      } else {
        toggleSubmit(true);
      }
      if (!starRating) {
        toggleSubmit(true);
      }
    } else if (starRating === 0 || typeof starRating === "undefined") {
      toggleReasonFlag(false);
      toggleSubmit(true);
    } else {
      toggleReasonFlag(false);
      if (isReadOnly) {
        toggleSubmit(true);
      } else {
        toggleSubmit(false);
      }
    }
  }, [starRating, comment, state, allInfo.getLearnerFeedback]);

  const handleStarClick = () => {
    if (starRating <= 3 && starRating !== 0) {
      toggleReasonFlag(true);
      toggleSubmit(true);
    } else if (starRating === 0) {
      toggleReasonFlag(false);
      toggleSubmit(true);
    } else {
      toggleReasonFlag(false);
      toggleSubmit(false);
    }
  };

  const handleClose = () => {
    if (!ReminderFlag && !isReadOnly) {
      sessionStorage.setItem("RemindLater", "true");
      setReminder(true);
    }
    toggleDialog(false);
    props.setRatingPopup(false);
  };

  const HandleCommentChange = (event: any) => {
    setComment(event.target.value);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  const HandleSubmit = (sessionRating: any, dispatch: any) => {
    const reasons: string[] = [];
    if (state.Content === true) {
      reasons.push("content");
    }
    if (state.Technology === true) {
      reasons.push("technology");
    }
    if (state.Teacher === true) {
      reasons.push("teacher");
    }

    const SessionId: number = sessionRating.SessionID;
    const Rating: number = starRating;
    const Source: string = "TMS";
    const UUID: string = sessionStorage.getItem("luuId") || "";
    const UserType: string = "attendee";
    let learnerToken = sessionStorage.getItem("JwToken") || "";
    if (!!!learnerToken && !!allInfo.learnerJWToken.data) {
      learnerToken = allInfo.learnerJWToken.data.getLearnerJwtoken;
    }
    const Reasons: String[] = reasons;

    let Comment = comment ? comment : "";
    Comment = Comment.replaceAll("\n", "\\n").replaceAll("\r", "\\r");
    const postFeedback = API.graphql(
      graphqlOperation(Createfeedback, { SessionId, UserType, UUID, Source, Rating, Comment, Reasons, learnerToken })
    ) as Promise<any>;
    postFeedback.then(
      () => {
        if (!!!allInfo.getLearnerFeedback.isLoading && !!allInfo.learnerJWToken.data) {
          sessionStorage.setItem("jwToken", allInfo.learnerJWToken.data.getLearnerJwtoken);
          dispatch(
            allActions.getLearnerFeedbackAction.getLearnerFeedback(allInfo.learnerJWToken.data.getLearnerJwtoken)
          );
        }

        toggleDialog(false);
        props.setRatingPopup(false);
        setReadOnly(true);
        toggleSubmit(true);
      },
      () => (err: Error) => {
        RollbarErrorTracking.logErrorInRollbar(err.message, "error");
      }
    );
  };

  return (
    <React.Fragment>
      <div className="ratings_container modalContent ui-dialog-content ui-widget-content" id="sessionRating">
        <div className="rating_info_grey_area">
          <div>
            <span>{translate("SessionRating_sessionDate")}</span>
            <span>{props.sessionRating.SessionDate}</span>
          </div>
          <div>
            <span>{translate("SessionRating_sessionTime")}</span>
            <span>{props.sessionRating.SessionTime}</span>
          </div>
          <div>
            <span>{translate("SessionRating_sessionDuration")}</span>
            <span>
              {props.sessionRating.SessionDuration} {translate("sessionRating_sessionDetails_mins")}
            </span>
          </div>
          <div>
            <span>{translate("SessionRating_status")}</span>
            <span className="completed">{translate("SessionRating_completed")}</span>
          </div>
        </div>

        <div className="ratings_info botttom_part"></div>
        <div className="star_ratings_container">
          <div className="star_ratings_block_head">{translate("SessionRating_rateYourExperience")} :</div>
          <div className="star_ratings_block">
            <span>
              <StarRatingBlock
                isEditable={!isReadOnly}
                value={starRating}
                onClick={handleStarClick}
                setStarRating={setStarRating}
              ></StarRatingBlock>
            </span>
          </div>
        </div>
        {reasonFlag && (
          <div className="star_ratings_reason_cover" id="what_went_wrong">
            <div className="star_ratings_reason_head">{translate("SessionRating_whatWentWrong")} :</div>
            <div className="star_ratings_reason">
              <FormGroup row>
                <FormControlLabel
                  control={<Checkbox disabled={isReadOnly} checked={Teacher} onChange={handleChange} name="Teacher" />}
                  label={translate("myschedule_sessionDetails_teacher_name")}
                />
                <FormControlLabel
                  control={<Checkbox disabled={isReadOnly} checked={Content} onChange={handleChange} name="Content" />}
                  label={translate("SessionRating_content")}
                />
                <FormControlLabel
                  control={
                    <Checkbox disabled={isReadOnly} checked={Technology} onChange={handleChange} name="Technology" />
                  }
                  label={translate("SessionRating_technology")}
                />
              </FormGroup>
            </div>
          </div>
        )}
        <div className="ratings_comment">
          <div className="star_ratings_block_head">{translate("SessionRating_comment")} : </div>
          <textarea aria-label="session feedback description"
            onChange={(event) => HandleCommentChange(event)}
            placeholder=""
            id="ratings_comment"
            value={
              props.sessionRating.Comment != "undefined" ? props.sessionRating.Comment : props.sessionRating.Comment
            }
            readOnly={isReadOnly}
            maxLength={256}
          ></textarea>
        </div>
        <div className="ratings_footer">
          <div className="ratings_mode_container enabled" id="ratings_submit">
            <div className="ratings_button_block">
              <button onClick={handleClose} className="button flat_button" id="ratings_remind_later_button" aria-label="Remind me later" role="button" tabIndex={0}>
                {!ReminderFlag && !isReadOnly ? translate("SessionRating_remindMeLater") : translate("SessionRating_close")}
              </button>
              <Button
                className="Submit_Button"
                type="button"
                variant="contained"
                disabled={submitButton}
                color="primary"
                aria-label="Submit"
                tabIndex={0}
                onClick={() => HandleSubmit(props.sessionRating, dispatch)}
              >
                <div className="submit-text">{translate("SessionRating_submit")}</div>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SessionRatingComponent;